<ng-container *ngIf="state$ | async as state">
    <div mat-dialog-title class="mat-dialog-header">
		<h2 class="dialog-title">{{ state.report?.title }} Share History</h2>
		<h3 class="dialog-subtitle">View the history of report shares, including when they were sent and to which emails.</h3>
	</div>

    <div mat-dialog-content class="share-history-content" [ngSwitch]="state.status">

        <!-- OK -->
        <ng-container *ngSwitchCase="'OK'">
            <div class="history-list">
                <ng-container *ngFor="let data of state.data">
                    <div class="history-icon">
                        <mat-icon mat-list-icon>share</mat-icon>
                    </div>
                    <mat-chip-list class="history-data">
                        <mat-chip *ngFor="let email of data.meta?.emails" disableRipple>{{ email }}</mat-chip>
                    </mat-chip-list>
                    <div class="history-info">
                        <div>Shared By: {{ data.user?.name }}</div>
                        <div>On: {{ data.createdAt | date:'mediumDate' }}</div>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <!-- LOADING -->
        <ng-container *ngSwitchCase="'LOADING'">
            <div class="info-wrapper">
                <mat-spinner></mat-spinner>
                <span>Loading History...</span>
            </div>
        </ng-container>

        <!-- EMPTY -->
        <ng-container *ngSwitchCase="'EMPTY'">
            <div class="info-wrapper">
                <mat-icon class="no-data-icon" [svgIcon]="'common:no_data'"></mat-icon>
                <span>No share history</span>
            </div>
        </ng-container>

        <!-- DEFAULT -->
        <ng-container *ngSwitchDefault>
            <div class="info-wrapper">
                <mat-icon color="warn">error</mat-icon>
                <span>An error occurred while loading the data</span>
            </div>
        </ng-container>
    </div>

    <mat-dialog-actions align="end">
        <button mat-flat-button color="primary" mat-dialog-close>Close</button>
    </mat-dialog-actions>
</ng-container>